module.exports = __webpack_public_path__ + "static/media/Icon - Chat Bubble - White.5947c3a6.svg";